import { useState, useEffect } from "react";
import { useNavigate, Link, useParams, useLocation } from "react-router-dom";
import PageLayout from "./common/PageApp";
import JobSearchBar from "../jobseeker/common/JobSearchBar";
import "../../Home.css";
import {
  getCities,
  getJobsByCategory,
  applyJob,
  saveJob,
} from "../../service/api";
import Select from "react-select";
import { toast } from "react-toastify";

const JobseekerJobCategory = () => {
  const { categoryId } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const initialJobTitle = params.get("title") || "";
  const initialCity = params.get("city") || "";
  const initialIndustry = params.get("industryType") || "";
  const initialJobType = params.get("jobType") || "";

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [btnloading, setBtnLoading] = useState(false);

  // filters
  const [jobTitle, setJobTitle] = useState(initialJobTitle);
  const [selectedCity, setSelectedCity] = useState(initialCity);

  // jobs data
  const [jobs, setJobs] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(12);
  const [totalPages, setTotalPages] = useState(1);
  const [totalResults, setTotalResults] = useState(0);

  const navigate = useNavigate();

  const [appliedFilters, setAppliedFilters] = useState({
    title: initialJobTitle,
    city: initialCity,
    industryType: initialIndustry,
    jobType: initialJobType,
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setAppliedFilters({
      title: params.get("title") || "",
      city: params.get("city") || "",
      industryType: params.get("industryType") || "",
      jobType: params.get("jobType") || "",
    });
  }, [location.search]);

  // fetch jobs by category
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setBtnLoading(true);
        setLoading(true);

        const res = await getJobsByCategory({
          categoryId,
          page,
          limit,
          city: appliedFilters.city || "",
          jobTitle: appliedFilters.title || "",
          industryType: appliedFilters.industryType || "",
          jobType: appliedFilters.jobType || "",
          experience: appliedFilters.experience || "",
          minSalary: appliedFilters.minSalary || "",
          maxSalary: appliedFilters.maxSalary || "",
        });

        setJobs(res.data.data || []);
        setTotalResults(res.data.totalRecord ?? res.data.data?.length ?? 0);
        setTotalPages(
          res.data.totalPage ?? Math.ceil((res.data.totalRecord ?? 0) / limit)
        );
        setPage(res.data.currentPage ?? page);
      } catch (err) {
        console.error(err);
      } finally {
        setBtnLoading(false);
        setLoading(false);
      }
    };

    fetchJobs();
  }, [page, limit, appliedFilters, categoryId]);

  const [loadingJobId, setLoadingJobId] = useState(null);

  const handleApply = async (jobId) => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    if (!token) {
      navigate("/jobseeker/login", {
        state: { from: window.location.pathname },
      });
      return;
    }

    if (role !== "job_seeker") {
      toast.error("Only jobseekers can apply for jobs!");
      return;
    }

    try {
      setLoadingJobId(jobId);
      const res = await applyJob({ jobPostId: jobId });
      toast.success(res.data.message || "Job applied successfully!");
    } catch (err) {
      toast.error(
        err.response?.data?.message || err.message || "Failed to apply for job."
      );
    } finally {
      setLoadingJobId(null);
    }
  };

  const [savedJobs, setSavedJobs] = useState([]);
  const [loadingSavedJobId, setLoadingSavedJobId] = useState(null);

  const handleSaveJob = async (jobId) => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/jobseeker/login", {
        state: { from: window.location.pathname },
      });
      return;
    }

    try {
      setLoadingSavedJobId(jobId);
      await saveJob(jobId);
      setSavedJobs((prev) =>
        prev.includes(jobId)
          ? prev.filter((id) => id !== jobId)
          : [...prev, jobId]
      );
      toast.success("Job saved successfully!");
    } catch (err) {
      toast.error(
        err.response?.data?.message || err.message || "Failed to save job."
      );
    } finally {
      setLoadingSavedJobId(null);
    }
  };

  return (
    <PageLayout>
      <section className="innerBnrNav">
        <div className="bnrNav">
          <div className="site-width">
            <div className="bnrNavWrap">
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Job Category</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="featuredjobs pt-50 pb-50">
        <div className="site-width">
          {/* Results Info + Limit */}
          <div className="listinfviewInfo row align-item-center justify-content-between mt-3">
            <div className="col-md-4">
              <div className="founderinfo">
                <p>{totalResults === 0 ? "No results found" : `${totalResults} Results Found`}</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="otherfilter">
                <select
                  name="limit"
                  id="record_limit"
                  value={limit}
                  onChange={(e) => {
                    setLimit(Number(e.target.value));
                    setPage(1);
                  }}
                >
                  <option value={12}>12 Per Page</option>
                  <option value={24}>24 Per Page</option>
                  <option value={36}>36 Per Page</option>
                </select>
              </div>
            </div>
          </div>

          <div className="jobListWrapper innerveiw">
            <div className="listWrap">
              <div className="row">
                <div className="col-3">
                  {/* Search Filter */}
                  <JobSearchBar
                    initialTitle={appliedFilters.title}
                    initialCity={appliedFilters.city}
                    initialIndustry={appliedFilters.industryType}
                    initialJobType={appliedFilters.jobType}
                    initialdExperienceRange={appliedFilters.experience}
                    initialMinSalary={appliedFilters.minSalary}
                    initialMaxSalary={appliedFilters.maxSalary}
                    btnLoading={btnloading}
                    onSearch={(filters) => {
                      setAppliedFilters({
                        ...filters,
                        minSalary: Number(filters.minSalary) || "",
                        maxSalary: Number(filters.maxSalary) || "",
                      });
                      setPage(1); // reset to first page on new search
                    }}
                  />
                </div>
                <div className="col-9">
                  <div className="row">
                    {loading ? (
                      <div className="text-center w-100 my-5">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : jobs.length === 0 ? (
                      <p></p>
                    ) : (
                      jobs.map((job) => (
                        <div className="col-md-4" key={job._id}>
                          <div className="astrocard position-relative">
                            <div
                              className="dropdown"
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                              }}
                            >
                              <button
                                className="btn btn-light btn-sm"
                                type="button"
                                style={{
                                  border: "none",
                                  background: "transparent",
                                  fontSize: "20px",
                                  color: "#eb642d",
                                }}
                                onClick={() => handleSaveJob(job._id)}
                                disabled={loadingSavedJobId === job._id}
                              >
                                {loadingSavedJobId === job._id ? (
                                  <i className="fa fa-spinner fa-spin"></i>
                                ) : savedJobs.includes(job._id) ? (
                                  <i className="fa-solid fa-bookmark"></i>
                                ) : (
                                  <i className="fa-regular fa-bookmark"></i>
                                )}
                              </button>
                            </div>
                            <div className="astrocContainer">
                              <div className="astrohead">
                                <div className="astroImg">
                                  <Link to={`/job-details/${job._id}`}>
                                    {job.companyImage ? (
                                      <img
                                        src={job.companyImage}
                                        alt="img"
                                        style={{ width: "150%" }}
                                      />
                                    ) : (
                                      <img
                                        src="/assets/img/company-profiles/image-1.png"
                                        alt="img"
                                        style={{ width: "150%" }}
                                      />
                                    )}
                                  </Link>
                                </div>
                              </div>
                              <div className="astroDetails">
                                <div className="astroName">
                                  <Link to={`/job-details/${job._id}`}>
                                    <h4>
                                      {job.jobTitle?.length > 20
                                        ? job.jobTitle.slice(0, 20) + "..."
                                        : job.jobTitle}{" "}
                                    </h4>
                                  </Link>

                                  <ul className="astroAcheiver companyName">
                                    <li>
                                      <img
                                        src="/assets/img/icons/office.svg"
                                        width="20"
                                        alt="icon"
                                      />
                                      <p>{job.company}</p>
                                    </li>
                                  </ul>

                                  <div className="astroinfo">
                                    <li>
                                      <img
                                        src="/assets/img/icons/location-.svg"
                                        alt="icon"
                                      />
                                      <span>{job.city}</span>
                                    </li>
                                    <li>
                                      <img
                                        src="/assets/img/icons/calender.svg"
                                        alt="icon"
                                      />
                                      <span>{job.jobPosted}</span>
                                    </li>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="astrolBtns flex-wrap">
                              {job.skills?.map((skill, idx) => (
                                <a
                                  key={idx}
                                  href="javascript:void(0)"
                                  className="astrocatbadge"
                                >
                                  {skill}
                                </a>
                              ))}
                            </div>

                            <div className="d-flex gap-2 align-item-center w-100 joblistfooter">
                              <span
                                style={{ height: "fit-content" }}
                                className="joblistrate"
                              >
                                ₹{job.minSalary} - ₹{job.maxSalary} (
                                {job.salaryType})
                              </span>
                            </div>
                            <div className="d-flex joblistfooter">
                              <a
                                href={`/job-details/${job._id}`}
                                className="mainbtn"
                                style={{
                                  backgroundColor: "#270b79",
                                  border: "1px solid #270b79",
                                }}
                              >
                                View Details
                              </a>
                              &nbsp;
                              <button
                                className="mainbtn"
                                onClick={() => handleApply(job._id)}
                                disabled={loadingJobId === job._id}
                              >
                                {loadingJobId === job._id ? (
                                  <span>
                                    <i
                                      className="fa fa-spinner fa-spin"
                                      style={{ marginRight: "8px" }}
                                    ></i>
                                    Applying...
                                  </span>
                                ) : (
                                  "Apply Now"
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      ))
                    )}

                    {/* Pagination */}
                    <div className="pagination-wrapper">
                      <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage((prev) => prev - 1)}
                      >
                        Prev
                      </button>

                      {Array.from({ length: totalPages }, (_, i) => i + 1)
                        .filter((pageNumber) => {
                          return (
                            pageNumber === 1 ||
                            pageNumber === totalPages ||
                            (pageNumber >= page - 1 && pageNumber <= page + 1)
                          );
                        })
                        .map((pageNumber, index, arr) => {
                          if (index > 0 && pageNumber - arr[index - 1] > 1) {
                            return (
                              <span key={`dots-${pageNumber}`} className="dots">
                                ...
                              </span>
                            );
                          }
                          return (
                            <button
                              key={pageNumber}
                              className={`pagination-btn ${
                                pageNumber === page ? "active" : ""
                              }`}
                              onClick={() => setPage(pageNumber)}
                            >
                              {pageNumber}
                            </button>
                          );
                        })}

                      <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage((prev) => prev + 1)}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default JobseekerJobCategory;
